/**
 * Ratgeber: TOC Scroll-Spy + smooth scroll (analog Plattform „Auf dieser Seite“).
 */

jQuery(document).ready(function ($) {
	const $scrollSpyNav = $('[data-scroll-spy]');
	if (!$scrollSpyNav.length) return;

	const $tocLinks = $scrollSpyNav.find('.ratgeber--toc__link');
	const $contentMain = $('.ratgeber--article__main');
	if (!$tocLinks.length || !$contentMain.length) return;

	const sections = [];
	$tocLinks.each(function () {
		const href = $(this).attr('href');
		if (!href || href.charAt(0) !== '#') return;
		const targetId = href.slice(1);
		const $target = $(document.getElementById(targetId));
		if ($target.length) {
			sections.push({
				id: targetId,
				$el: $target,
				$link: $(this),
			});
		}
	});

	if (!sections.length) return;

	/** Offset unter fixem Header; abgleichend mit Rockyourlife-Scroll-Spy (sichtbare Trigger-Linie). */
	const scrollOffset = () => {
		const navEl = document.querySelector('.site-header');
		const h = navEl ? navEl.getBoundingClientRect().height : 0;
		return Math.round(Math.max(h + 24, 120));
	};

	$tocLinks.on('click', function (e) {
		e.preventDefault();
		const href = $(this).attr('href');
		if (!href || href.charAt(0) !== '#') return;
		const targetId = href.slice(1);
		const target = document.getElementById(targetId);
		if (target) {
			$tocLinks.removeClass('is-active');
			$(this).addClass('is-active');
			const off = scrollOffset();
			const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - off;
			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth',
			});
			window.history.pushState(null, '', '#' + targetId);
		}
	});

	let ticking = false;

	function updateActiveLink() {
		const off = scrollOffset();
		const scrollPos = $(window).scrollTop();
		const winHeight = $(window).height();
		const docHeight = $(document).height();
		// Etwas unterhalb der Header-Kante (analog localmedia ~190px Trigger)
		const triggerLine = scrollPos + off + 24;
		let currentSection = null;

		for (let i = sections.length - 1; i >= 0; i--) {
			const section = sections[i];
			const sectionTop = section.$el.offset().top;
			if (sectionTop <= triggerLine) {
				currentSection = section;
				break;
			}
		}

		if (scrollPos + winHeight >= docHeight - 2) {
			currentSection = sections[sections.length - 1];
		}

		$tocLinks.removeClass('is-active');
		if (currentSection) {
			currentSection.$link.addClass('is-active');
		}

		ticking = false;
	}

	$(window).on('scroll', function () {
		if (!ticking) {
			window.requestAnimationFrame(function () {
				updateActiveLink();
			});
			ticking = true;
		}
	});

	updateActiveLink();

	function smoothScrollToHash(hash) {
		if (!hash || hash.charAt(0) !== '#') return;
		const target = document.querySelector(hash);
		if (target) {
			const off = scrollOffset();
			const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - off;
			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth',
			});
		}
	}

	$(window).on('hashchange', function () {
		smoothScrollToHash(window.location.hash);
	});

	if (window.location.hash) {
		setTimeout(function () {
			smoothScrollToHash(window.location.hash);
		}, 100);
	}
});
